import {uploadBase64FileWithServe, uploadFileWithServe} from "@/api/file-api";

export const uploadFile = (file, path) => {
    return uploadFileWithSelfServe(file, path)
}

export const uploadBase64File = (base64Image, path) => {
    return uploadBase64FileWithServe(base64Image, path)
}

export const getFileUrl = (path) => {
    return getFileUrlWithSelfServe(path)
}

function uploadFileWithSelfServe(file, objectKey) {
    console.log("uploadFileWithSelfServe", file, objectKey)
    return uploadFileWithServe(file.raw, objectKey)
}

function getFileUrlWithSelfServe(objectKey) {
    // 与 visitor-h5 口径一致：静态站点由 nginx 把 /api/file/download 映射到文件存储根目录
    return "/api/file/download/" + objectKey
}

function toBlob(urlData, fileType) {
    let bytes = window.atob(urlData);
    let n = bytes.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bytes.charCodeAt(n);
    }
    return new Blob([u8arr], {type: fileType});
}
